import { writable } from "svelte/store"

export let commandsData = writable([
  {
    line: "cat index.js",
    timeout: 10,
    path: "/home",
    shouldType: true
  },
  {
    line: "const helper = require('helper.js')",
    timeout: 0,
    path: "",
    shouldType: false
  },
  {
    line: "helper.startValidation()",
    timeout: 0,
    path: "",
    shouldType: false
  },
  {
    line: "node index.js",
    timeout: 50,
    path: "/home",
    shouldType: true
  },
  {
    line: "validation started!",
    timeout: 100,
    path: "",
    shouldType: false
  },
  {
    line: "validation completed!",
    timeout: 300,
    path: "",
    shouldType: false
  },
  {
    line: "",
    timeout: 50,
    path: "/home",
    shouldType: false
  }
])

export const setCommandsData = (commands) => (commandsData = commands)

export const changelogData = [
  {
    date: "28.02.2023",
    changelogs: [
      "Revamped UI.",
      "Improved path and texting animation to be adjustable by command line.",
      "Improved screen size, colors, and font size settings by making customizable."
    ]
  },
  {
    date: "5.07.2021",
    changelogs: ["Font change bug fixed", "'Consolas Bold', 'Courier Prime Bold' added"]
  },
  {
    date: "4.07.2021",
    changelogs: ["'Font Size' and 'Font Family' selections added to General Settings. You can use new fonts in terminal easily."]
  },
  {
    date: "3.07.2021",
    changelogs: ["'Typing Animation' feature added to General Settings. This feature makes command typing more effective."]
  },
  {
    date: "2.07.2021",
    changelogs: ["First Release"]
  }
]
